/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import { queryOptions, useQuery } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  FindContactrMappingQueryResponse,
  FindContactrMappingQueryParams,
} from "../types/FindContactrMapping.ts"

export const findContactrMappingQueryKey = (
  params: FindContactrMappingQueryParams
) =>
  [
    { url: "/v1/client-settings/find-supplier-mapping" },
    ...(params ? [params] : []),
  ] as const

export type FindContactrMappingQueryKey = ReturnType<
  typeof findContactrMappingQueryKey
>

/**
 * @summary Find contact
 * {@link /v1/client-settings/find-supplier-mapping}
 */
export async function findContactrMapping(
  params: FindContactrMappingQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindContactrMappingQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/client-settings/find-supplier-mapping`,
    params,
    ...requestConfig,
  })
  return res
}

export function findContactrMappingQueryOptions(
  params: FindContactrMappingQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const queryKey = findContactrMappingQueryKey(params)
  return queryOptions<
    ResponseConfig<FindContactrMappingQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindContactrMappingQueryResponse>,
    typeof queryKey
  >({
    enabled: !!params,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal
      return findContactrMapping(params, config)
    },
  })
}

/**
 * @summary Find contact
 * {@link /v1/client-settings/find-supplier-mapping}
 */
export function useFindContactrMapping<
  TData = ResponseConfig<FindContactrMappingQueryResponse>,
  TQueryData = ResponseConfig<FindContactrMappingQueryResponse>,
  TQueryKey extends QueryKey = FindContactrMappingQueryKey,
>(
  params: FindContactrMappingQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindContactrMappingQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof fetch }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...queryOptions } = queryConfig
  const queryKey = queryOptions?.queryKey ?? findContactrMappingQueryKey(params)

  const query = useQuery(
    {
      ...findContactrMappingQueryOptions(params, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
